import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, RouterModule, RouterLink, RouterOutlet, RouterLinkActive } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { TokenStorageService } from 'src/app/services/token_storage.service';
import { AppState } from 'src/app/store/models/app-state.model';
import { ShoppingItem } from 'src/app/store/models/shopping-item.model';
import { AddItemAction, NewListAction, UpdateNotifications } from 'src/app/store/actions/shopping.actions';
import { UserNotificationService } from 'src/app/services/user-notification.service';
import { MatSidenavContainer, MatSidenav, MatSidenavContent, MatSidenavModule } from "@angular/material/sidenav";
import { MatListItem, MatListModule, MatNavList } from "@angular/material/list";
import { MatToolbar } from "@angular/material/toolbar";
import { MatIcon } from "@angular/material/icon";
import { KeyValuePipe } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButton, MatButtonModule, MatIconButton } from '@angular/material/button';


@Component({
    selector: 'navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    imports: [
        MatSidenavContainer,
        MatSidenav, 
        MatListModule, 
        MatSidenavContent, 
        RouterModule, 
        MatToolbar, 
        MatIcon,
        MatIconButton,
        RouterLink, 
        KeyValuePipe, 
        MatFormFieldModule, 
        MatInputModule, 
        MatSidenavModule,
        RouterOutlet,
        MatButtonModule,
        RouterLinkActive, 
        RouterModule,
        MatListModule
    ]
})

export class NavbarComponent implements OnInit {
    opened = false;
    shoppingItems: Observable<ShoppingItem[]> | undefined;
    notificationsStoreCount: Observable<number> | undefined;
    upperNewsLink: string  = 'https://ontheupper.com/'

    cart: any[] = [];
    itemCount: any = 0;
    notificationsCount: any = 0;

    constructor(
        private router: Router,
        private tokenStorage: TokenStorageService,
        private store: Store<AppState>,
        private notificationService: UserNotificationService,
    ) { 
}

    ngOnInit(): void {
        this.notificationsStoreCount = this.store.select(store => store.shopping.notifications);
        this.shoppingItems = this.store.select(store => store.shopping.items);
        this.notificationsStoreCount.subscribe(count => {
            this.notificationsCount = count;
        });
        this.shoppingItems.subscribe(cartItems => {
            this.cart = cartItems;
            this.updateTotal();
        });
        // this.getNotifications();
    }

    updateTotal(): void {
        let total = 0;
        this.cart.forEach(item => {
            total += item.quantity;
        })
        this.itemCount = total;
    }


    getNotifications(): void {
        const getUser = this.tokenStorage.getUser();
        
        if (getUser && Object.keys(getUser).length > 0 && this.tokenStorage.getToken() != null) {
            const map = new Map();
            this.notificationService.get([getUser.id, 'false'], map).subscribe((result) => {
                this.notificationsCount = result.length;
            });
        }
    }

    routes = new Map([
        ['home', 'Shop Services'],
        //['application', 'Application'],
        // ['profile', 'Profile'],
    ]);

    logout(): void {
        this.notificationsCount = 0;
        this.store.dispatch(new UpdateNotifications(0));
        sessionStorage.clear();
        this.tokenStorage.signOut();
        this.store.dispatch(new NewListAction([]));
        this.router.navigate(['login']);
    }

    toggleSidenav(): void {
        this.opened = !this.opened;
    }

    logInScreen(): void {
        this.router.navigate(['login']);
    }

    navigateToCheckout(): void {
        this.router.navigate(['checkout']);
    }

    navigateToNotificationsManagement(): void {
        this.router.navigate(['notifications-management']);
    }

    navigateToSubscriptionManagement(): void {
        this.router.navigate(['subscription-management']);
    }

    isMobile() {
        //Changed to just return to check if I like the navbar always set to over
        return true;
        // const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        // if (width < 768) {
        //     return true;
        // } else {
        //     return false;
        // }
    }

    get isUserLoggedIn(): boolean {
        if (this.tokenStorage.getUser() != null && this.tokenStorage.getToken() != null) {
            return true;
        }
        return false;
    }
}
